{
    "ModalTitleAdd": "Nieuw rapport toevoegen",
    "ModalTitleModify": "Rapport wijzigen",
    "ModalTitleDateTime": "Date",
    "TabnameReport": "Rapport",
    "TabnameFilter": "Filter",
    "TabnameOther": "Ander",
    "TabnameFields": "Velden",
    "TabnameDashboard": "Lay-out",
    "TabnameSlakpi": "SLA\/KPI",
    "TabnameAlarms": "Alarmen",
    "TabnameScheduling": "Het roosteren",
    "TabnameAcdCodes": "Codes",
    "TabnameFinancial": "financieel",
    "TabnameSettings": "Aangepaste instellingen",
    "TabnamePrint": "Afdrukuitvoeropties",
    "TabnameAdvanced": "Geavanceerd",
    "ReporttypelabelNolistitems": "Geen huidige lijstitems met die naam.",
    "ConfigureReport_ButtonHelpLabel": "Helpen?",
    "ConfigureReport_ButtonSubmitLabel": "Oke",
    "ConfigureReport_ButtonCancelLabel": "Annuleren",
    "ConfigureReport_PromptMessage": "Weet u zeker dat u dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren wanneer ze worden gesloten.",
    "ConfigureReport_PromptConfirm": "Ja",
    "ConfigureReport_PromptCancel": "Annuleren",
    "ConfigureReport_Basic": "Basis",
    "ConfigureReport_Advanced": "Geavanceerd",
    "NAME": "ConfigureReport"
}